@if (!loaded()) {
  <app-chart-placeholder></app-chart-placeholder>
}

@if (loaded()) {
  <highcharts-chart
    [options]="chartOptions"
    [constructorType]="chartConstructor"
    style="width: 100%; height: auto; display: block"
  ></highcharts-chart>
}
